const DEVICE_BREAKPOINTS = {
  MOBILE: 576,
  TABLET: 768,
  LAPTOP: 992,
  DESKTOP: 1200,
  LARGESCREEN: 1800
};

export default DEVICE_BREAKPOINTS;
